module.exports = __webpack_public_path__ + "img/hr-puberty-decal-02.d01bd77d.png";